// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"87737eff","703":"3d3b358f"}[chunkId] + ".chunk.js";
};